export default "__VITE_ASSET__DTWh4AKX__"